<template>
  <div class="select">
    <div v-if="value" class="select__value">{{ props.value }}</div>
    <div v-else class="select__placeholder">{{ placeholder }}</div>

    <Button class="select__button" @click="onSelectClick">Select</Button>
  </div>
</template>

<script setup>
import Button from '@/ui/Button.vue'

import { useLayoutStore } from '@/store'

const layoutStore = useLayoutStore()

const props = defineProps({
  value: {
    type: [String, Number],
  },

  placeholder: {
    type: String,
  },

  isFft: {
    type: Boolean,
  },
})

function onSelectClick() {
  layoutStore.showModal('ModalSelect', {
    isFft: props.isFft,
  })
}
</script>

<style lang="sass">
.select
  display: flex
  align-items: center
  justify-content: space-between
  background-color: white
  padding-left: 12px

  &__value,
  &__placeholder
    font-size: 28px
    line-height: 28px
    color: black

  &__placeholder
    color: gray
    user-select: none

</style>